import brain from "./images/brain.svg";
import printer from "./images/printer.svg";
import controller from "./images/controller.svg";
import hero from "./images/hero.png";
import { API_HOST } from "./config";
import { apiClient } from "sessions/server";
import { useState } from "react";

export const Home = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [subscribeToNewsletter, setSubscribeToNewsletter] = useState(false);
    function tiltEffect(e) {
        const card = e.target.closest(".feature-card");
        if (!card) return;
        const r = card.getBoundingClientRect();
        const cx = e.clientX - r.left;
        const cy = e.clientY - r.top;
        const rx = (cy / r.height - 0.5) * -4;
        const ry = (cx / r.width - 0.5) * 4;
        card.style.transform = `perspective(600px) rotateX(${rx}deg) rotateY(${ry}deg)`;
        card.style.borderColor =
            "color-mix(in oklab, var(--bg), var(--text) 18%)";
    }

    function resetTilt(e) {
        const grid = document.getElementById("features");
        grid.querySelectorAll(".feature-card").forEach((c) => {
            c.style.transform = "";
            c.style.borderColor = "var(--bg)";
        });
    }

    const show = (el, msg) => {
        el &&
            (msg ? (el.textContent = msg) : null, el.removeAttribute("hidden"));
    };
    const hide = (el) => el && el.setAttribute("hidden", "");

    function submitSignup(e) {
        e.preventDefault();
        if (isLoading) return;
        setIsLoading(true);
        if (e.target.company.value) {
            return; // bot detected via honeypot
        }
        if (!e.target.email.value) {
            return; // no email
        }
        const data = {
            email: e.target.email.value,
            receive_newsletters: subscribeToNewsletter,
        };
        apiClient
            .post("/users/subscribe/", data)
            .then((response) => {
                const successEl = document.getElementById("form-success");
                const errorEl = document.getElementById("form-error");
                if (!response.status.toString().startsWith("20")) {
                    errorEl.textContent =
                        response?.data?.email?.[0] || "Oops—please try again.";
                    show(errorEl);
                } else {
                    hide(errorEl);
                    show(successEl);
                    e.target.reset();
                    setSubscribeToNewsletter(false);
                    setTimeout(hide, 5000, successEl);
                }
            })
            .catch((error) => {
                const successEl = document.getElementById("form-success");
                const errorEl = document.getElementById("form-error");
                hide(successEl);
                show(errorEl, error.message || "Oops—please try again.");
                setTimeout(hide, 5000, errorEl);
            });
        setIsLoading(false);
    }

    return (
        <main>
            <section id="hero" className="hero">
                <div className="container hero-grid">
                    <div className="hero-copy">
                        <h1 className="logo">tinkrverse</h1>
                        <p id="product-tagline" className="lead">
                            Let your imagination take control.
                        </p>

                        <div className="cta-row">
                            <a
                                href="#signup"
                                className="btn btn-primary"
                                id="cta-primary"
                            >
                                Join the waitlist
                            </a>
                        </div>
                    </div>
                    <div className="hero-media hero-glow">
                        <img id="hero-img" src={hero} alt="Product image" />
                        <div className="hero-overlay" aria-hidden="true"></div>
                    </div>
                </div>
            </section>

            <section id="features-section" className="section">
                <div className="container">
                    <h2 className="section-title">
                        Your journey in the tinkrverse
                    </h2>
                    <div
                        id="features"
                        className="features-grid"
                        onMouseMove={tiltEffect}
                        onMouseLeave={resetTilt}
                    >
                        <div className="feature-card">
                            <div className="feature-icon" aria-hidden="true">
                                <img src={brain} alt="" />
                            </div>
                            <h3 className="feature-title">Prototype</h3>
                            <p className="feature-description">
                                Start from a template or design from scratch,
                                your imagination sets the limit.
                            </p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon" aria-hidden="true">
                                <img src={printer} alt="" />
                            </div>
                            <h3 className="feature-title">Print</h3>
                            <p className="feature-description">
                                Download the 3D model and print it with your
                                favorite printer or have it shipped to your
                                doorstep.
                            </p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon" aria-hidden="true">
                                <img src={controller} alt="" />
                            </div>
                            <h3 className="feature-title">Play</h3>
                            <p className="feature-description">
                                Bring your idea to life. Test it, tweak it,
                                share it with the community.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="signup" className="section signup">
                <div className="container signup-card">
                    <h2 id="signup-title" className="section-title">
                        Get early access
                    </h2>
                    <p id="signup-subtitle">
                        Be the first to know when it's ready. By signing up, you
                        agree to the{" "}
                        <a href="/privacy-policy">Privacy Policy</a> and{" "}
                        <a href="/terms">Terms of Service</a>.
                    </p>
                    <form
                        id="signup-form"
                        className="signup-form"
                        method="POST"
                        action=""
                        onSubmit={submitSignup}
                    >
                        <div className="hp" aria-hidden="true">
                            <label>
                                <input
                                    type="text"
                                    name="company"
                                    tabIndex="-1"
                                    autoComplete="off"
                                />
                            </label>
                        </div>

                        <div className="fields">
                            <input
                                id="email-input"
                                name="email"
                                type="email"
                                inputMode="email"
                                autoComplete="email"
                                placeholder="Your email"
                                required
                            />
                            <button
                                id="signup-submit"
                                type="submit"
                                disabled={isLoading}
                                className="btn btn-primary"
                            >
                                Notify me
                            </button>
                        </div>
                        <div className="newsletter-checkbox">
                            <label>
                                <input
                                    type="checkbox"
                                    name="receive_newsletters"
                                    id="newsletter-checkbox"
                                    checked={subscribeToNewsletter}
                                    onChange={(e) =>
                                        setSubscribeToNewsletter(
                                            e.target.checked,
                                        )
                                    }
                                />
                                <span>
                                    Subscribe to the newsletter for updates and
                                    models
                                </span>
                            </label>
                        </div>
                        <p id="form-success" className="success" hidden>
                            Thanks! You're on the list.
                        </p>
                        <p id="form-error" className="error" hidden>
                            Oops—please try again.
                        </p>
                    </form>
                </div>
            </section>
        </main>
    );
};
